var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftMembershipStepAccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.2435 11.041H5.07334C4.03171 11.041 3.19202 10.2013 3.19202 9.15965C3.19202 8.12864 4.03171 7.27832 5.07334 7.27832H14.0017C15.798 7.27832 17.2435 8.73449 17.2435 10.5202V11.041Z",
    fill: "#284993"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.26294 12.9961H19.4331C20.4748 12.9961 21.3144 13.8358 21.3144 14.8774C21.3144 15.9191 20.4748 16.7587 19.4331 16.7587H11.0256C8.94232 16.7587 7.26294 15.0794 7.26294 12.9961Z",
    fill: "#284993"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2363 18.7148V19.1931C13.2363 20.2348 14.076 21.0745 15.1177 21.0745C16.1593 21.0745 16.999 20.2348 16.999 19.1931V18.7148H13.2363Z",
    fill: "#284993"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2701 5.32241V4.83348C11.2701 3.79184 10.4304 2.95215 9.38877 2.95215C8.35776 2.96278 7.51807 3.80247 7.51807 4.83348V5.31178H11.2701V5.32241Z",
    fill: "#284993"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftMembershipStepAccess);
export default __webpack_public_path__ + "static/media/gift-membership-step-access.c31e5aa0340bf61ae958c2985f42896c.svg";
export { ForwardRef as ReactComponent };